<template>
    <kgr-icon
        icon-class="warning"
        :title="title"
        class="kgr-icon--warning"
    />
</template>
<script>
import Icon from './Icon.vue';

export default {
    components: {
        'kgr-icon': Icon,
    },
    props: {
        title: {
            type: String,
            required: false,
            default: '',
        },
    }
}
</script>
